import { Injectable } from '@angular/core';
import { CrudApiServiceService, DeliveryAddress } from '@us/web/shared/data-access';

@Injectable({
    providedIn: 'root'
})
export class DeliveryAddressService extends CrudApiServiceService<DeliveryAddress> {
    getEndpoint(): string {
        return 'delivery-addresses';
    }
}
